import styled from 'styled-components';
const UICardHero = styled.div.withConfig({
  displayName: "UICardHero",
  componentId: "ffvc3x-0"
})(["border-top-left-radius:inherit;border-top-right-radius:inherit;overflow:hidden;"]);
UICardHero.displayName = 'UICardHero';
export default UICardHero;